import { Component, effect, Input, OnChanges } from '@angular/core';
import { NgxEchartsDirective } from 'ngx-echarts';
import { EChartsOption } from 'echarts';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import {
  DASHBOARD_CHART_PALETTES,
  DashboardChartPalette,
  ECHARTS_THEMES,
} from '../../../../shared/services/echarts/echarts.config';
import { ThemeService } from '../../../../shared/services/theme/theme.service';
import { GaugeMetric } from '../../../../shared/models/interfaces/dashboard/dashboard.interface';

@Component({
  selector: 'l-dashboard-gauge-chart',
  standalone: true,
  imports: [NgxEchartsDirective, IconComponent],
  templateUrl: './dashboard-gauge-chart.component.html',
})
export class DashboardGaugeChartComponent implements OnChanges {

  constructor(private readonly themeService: ThemeService) {
    effect(() => {
      this.palette = DASHBOARD_CHART_PALETTES[this.themeService.theme()];

      if (this.metric) {
        this.chartOptions = this.buildOptions();
      }
    });
  }

  @Input({ required: true })
  public metric!: GaugeMetric;

  public chartOptions: EChartsOption = {};

  public readonly theme = ECHARTS_THEMES[this.themeService.theme()];

  private palette: DashboardChartPalette = DASHBOARD_CHART_PALETTES[this.themeService.theme()];

  public ngOnChanges(): void {
    this.chartOptions = this.buildOptions();
  }

  private buildOptions(): EChartsOption {
    return {
      series: [
        {
          type: 'gauge',
          startAngle: 180,
          endAngle: 0,
          min: 0,
          max: this.metric.maxValue,
          splitNumber: 5,
          radius: '115%',
          center: ['50%', '75%'],
          axisLine: {
            roundCap: true,
            lineStyle: {
              width: 14,
              color: [[1, this.palette.track]],
            },
          },
          progress: {
            show: true,
            roundCap: true,
            width: 14,
            itemStyle: {
              color: this.palette.progress,
            },
          },
          pointer: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: { show: false },
          detail: {
            valueAnimation: true,
            formatter: () => this.metric.value.toFixed(1),
            color: this.palette.text,
            fontSize: 22,
            fontWeight: 700,
            offsetCenter: [0, '-12%'],
          },
          data: [{ value: this.metric.value }],
        },
      ],
    };
  }

}
